import React from 'react'

interface FormFieldProps {
  label?: string
  description?: string
  errorText?: string
  constraintText?: string
  children: React.ReactNode
}

export const FormField: React.FC<FormFieldProps> = ({ label, description, errorText, children }) => {
  return (
    <div style={{ marginBottom: '16px' }}>
      {label && <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>{label}</label>}
      {description && <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{description}</div>}
      {children}
      {errorText && <div style={{ fontSize: '12px', color: '#d91515', marginTop: '4px' }}>{errorText}</div>}
    </div>
  )
}
